// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}

(function() {
  faq_taggol();
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");
})();

// accordions js end

// Menu Hover Start
let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
      items.forEach(item => {
       item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
         item.querySelector("ul").addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
         item.addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
       });
      });
  }
// Menu Hover end

//Product page Tab section
var tabTitles = document.querySelectorAll(".product-tab-wrapper .tab-title");
tabTitles && tabTitles.forEach(function(tabTitle, index) {
    tabTitle.addEventListener("click", function() {
        var swiperElement = tabTitle.closest(".swiper")
          , swiperInstance = swiperElement.swiper;
        swiperInstance.slideTo(index),
        tabTitles.forEach(function(tabTitle2) {
            tabTitle2.classList.remove("active"),
            tabTitle2.classList.remove("swiper-slide-active")
        }),
        tabTitle.classList.add("active"),
        tabTitle.classList.add("swiper-slide-active");
        var tab = tabTitle.getAttribute("data-tab-title")
          , tabWrappers = document.querySelectorAll(".product-tab-contents .tab-content");
        tabWrappers && tabWrappers.forEach(function(tabwrapper) {
            tabwrapper.classList.remove("active");
            var tabContent = tabwrapper.getAttribute("data-tab");
            tab == tabContent && tabwrapper.classList.add("active")
        })
    })
});
//Product page Tab section end
// product page review_badge click and scroll down to show
var review_badge = document.querySelector(".loox-rating");
review_badge && review_badge.addEventListener("click", function() {    
    document.querySelector(".product-tab-titles .tab-title[data-tab-title='Bewertungen']").click()
});

if(document.querySelector(".readmore-btn")){
// Select all elements with the class 'readmore-btn'
 const buttons = document.querySelectorAll(".readmore-btn");
  buttons.forEach(button => {
    button.addEventListener("click", function() {
        this.parentElement.classList.toggle('open');
        const buttonText = this.parentElement.classList.contains('open') ? this.getAttribute('data-read-leass') : this.getAttribute('data-read-more');
        this.textContent = buttonText;
    });
  });
}

// product main media slider
var Product_swiper = new Swiper(".custom_slider_pdp[custom_product_slider]",{
    slidesPerView:1,
    spaceBetween:10,
    autoHeight: true,
    navigation:{
      nextEl:".swiper-button-next",
      prevEl:".swiper-button-prev"
    },
    keyboard:{
      enabled:true,
      onlyInViewport:true
    },
    allowTouchMove: true,
    speed:1000,
    thumbs:{
      swiper:{
        slidesPerView:4,
        el:".swiprt_thumbnail_slider",
        slidesPerView:1,
        spaceBetween:15,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        navigation:{
            nextEl:".swiper-button-next.thumb",
            prevEl:".swiper-button-prev.thumb"
        },
        breakpoints:{
          0: {
            slidesPerView:4
          }
        }
      }
    }
});


document.addEventListener('DOMContentLoaded', function () {

  if (window.location.hash === '#Review-tab') {

    const reviewTab = document.getElementById('Review-tab');

    if (reviewTab) {

      reviewTab.click();

      setTimeout(() => {
        reviewTab.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);

    }

  }

});

// TZN Duz-Fix Start
(function () {
  var excludedPaths = [
    /\/policies\//i,
    /\/pages\/widerruf/i,
    /\/pages\/teilnahmebedingungen/i,
    /\/pages\/datenschutz/i,
    /\/pages\/impressum/i,
    /\/pages\/agb/i
  ];

  if (excludedPaths.some(function (pattern) { return pattern.test(window.location.pathname); })) {
    return;
  }

  var replacements = [
    ['Gute Auswahl. Hier sind Ihre Produkte', 'Gute Auswahl. Hier sind deine Produkte'],
    ['Hier sind Ihre Produkte', 'Hier sind deine Produkte'],
    ['Empfehlungen für Dich', 'Empfehlungen für dich'],
    ['Melde Dich', 'Melde dich'],
    ['Wie können wir Dir weiterhelfen?', 'Wie können wir dir weiterhelfen?'],
    ['Wenn Du in unseren FAQ’s keine Antwort gefunden hast, stehen wir Ihnen gerne mit unserer Hilfe zur Seite.', 'Wenn du in unseren FAQ’s keine Antwort gefunden hast, stehen wir dir gerne mit unserer Hilfe zur Seite.'],
    ['Gerne beraten wir Dich', 'Gerne beraten wir dich'],
    ['für Dich dabei war', 'für dich dabei war'],
    ['Wir unterstützten Dich gerne', 'Wir unterstützen dich gerne'],
    ['Wir unterstützen Dich gerne', 'Wir unterstützen dich gerne'],
    ['sicheren Halt Ihrer Getränke', 'sicheren Halt deiner Getränke'],
    ['Praktische Features für Ihre Bedürfnisse', 'Praktische Features für deine Bedürfnisse'],
    ['Die Montage am rechten A-Holm Ihres John Deere 6R Traktors', 'Die Montage am rechten A-Holm deines John Deere 6R Traktors'],
    ['Bitte beachten Sie, dass der Versand Ihrer Bestellung bis zu 10 Werktage nach dem Bestelldatum erfolgen kann. Vielen Dank für Ihr Verständnis.', 'Bitte beachte, dass der Versand deiner Bestellung bis zu 10 Werktage nach dem Bestelldatum erfolgen kann. Vielen Dank für dein Verständnis.'],
    ['die Ihnen eine effiziente Nutzung ermöglicht', 'die dir eine effiziente Nutzung ermöglichen'],
    ['Ihnen jederzeit zur Verfügung.', 'dir jederzeit zur Verfügung.'],
    ['Bestellen Sie einfach und bequem online über unseren Shop.', 'Bestelle einfach und bequem online über unseren Shop.'],
    ['Entdecken Sie die optimale Lösung', 'Entdecke die optimale Lösung'],
    ['Besuchen Sie ', 'Besuche '],
    [' und finden Sie die perfekte Ausstattung für Ihre Traktorkabine.', ' und finde die perfekte Ausstattung für deine Traktorkabine.'],
    ['Das praktische Kreuz bietet Ihnen verschiedene Platzierungsmöglichkeiten.', 'Das praktische Kreuz bietet dir verschiedene Platzierungsmöglichkeiten.']
  ];

  function applyReplacements(text) {
    var output = text;
    replacements.forEach(function (pair) {
      output = output.split(pair[0]).join(pair[1]);
    });
    return output;
  }

  function shouldSkipNode(node) {
    if (!node || !node.parentElement) return true;
    return Boolean(node.parentElement.closest('script, style, noscript, textarea, input, select, option'));
  }

  function processTextNode(node) {
    if (shouldSkipNode(node)) return;
    var updated = applyReplacements(node.nodeValue);
    if (updated !== node.nodeValue) node.nodeValue = updated;
  }

  function processRoot(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var currentNode;
    while ((currentNode = walker.nextNode())) {
      nodes.push(currentNode);
    }
    nodes.forEach(processTextNode);
  }

  function runDuzFix() {
    processRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runDuzFix);
  } else {
    runDuzFix();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          processTextNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          processRoot(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
// TZN Duz-Fix End

// TZN Sale-Styling-Fix Start
(function () {
  var styleId = 'tzn-sale-styling-fix';

  function injectSaleStyles() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      ':root { --tzn-sale-red: #D03131; }',
      '.badge.badge_sale, .badge.price__badge-sale, .tzn-sale-badge, body .os-page-container [class*="sale-badge" i], body .os-page-container [class*="sale_badge" i], body .os-page-container [class*="discount-badge" i], body .os-page-container [class*="discount_badge" i], body .os-page-container [class*="reduced-badge" i], body .os-page-container [class*="reduced_badge" i], body .os-page-container [class*="badge" i][class*="sale" i], body .os-page-container [class*="badge" i][class*="discount" i], body .os-page-container [class*="badge" i][class*="reduced" i] { background-color: var(--tzn-sale-red) !important; border-color: var(--tzn-sale-red) !important; color: #fff !important; }',
      '.tzn-sale-badge { border: 1px solid var(--tzn-sale-red) !important; }',
      '.card-wrapper .price.price--on-sale .price-item--regular, .price.price--on-sale .price-item--regular, .price.price--on-sale s.price-item--regular, body .os-page-container s, body .os-page-container del, body .os-page-container [class*="compare" i], body .os-page-container [class*="old" i][class*="price" i], body .os-page-container [class*="strike" i] { color: var(--tzn-sale-red) !important; text-decoration-color: var(--tzn-sale-red) !important; }'
    ].join('\n');

    document.head.appendChild(style);
  }

  function shouldCheckElement(element) {
    if (!element || !element.textContent) return false;
    if (element.closest('script, style, noscript, textarea, input, select, option')) return false;
    return Boolean(element.closest('.os-page-container, .product-grid, .collection, .template-search'));
  }

  function markSaleBadge(element) {
    if (!shouldCheckElement(element)) return;

    var text = element.textContent.trim().replace(/\s+/g, ' ');
    if (/^(reduziert|sale)$/i.test(text)) {
      element.classList.add('tzn-sale-badge');
    }
  }

  function processSaleRoot(root) {
    if (!root) return;

    if (root.nodeType === Node.ELEMENT_NODE) {
      markSaleBadge(root);

      if (root.querySelectorAll) {
        root.querySelectorAll('.os-page-container *, .product-grid *, .collection *, .template-search *').forEach(markSaleBadge);
      }
    }
  }

  function runSaleStylingFix(root) {
    injectSaleStyles();
    processSaleRoot(root || document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runSaleStylingFix(document.body);
    });
  } else {
    runSaleStylingFix(document.body);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          runSaleStylingFix(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
// TZN Sale-Styling-Fix End
